import React, { useState } from 'react';

import { DevModeContext } from '../devModeContext/DevModeContext';

import { DevModeContextControllerProps } from './DevModeContextController.types';

export const DevModeContextController = ({ children }: DevModeContextControllerProps) => {
  const [devMode, setDevMode] = useState<boolean>(false);

  return <DevModeContext.Provider value={{ devMode, setDevMode }}>{children}</DevModeContext.Provider>;
};
